var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "addactivity_div"
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-steps", {
    staticClass: "steps",
    attrs: {
      current: _vm.currentTab
    }
  }, [_c("a-step", {
    attrs: {
      title: _vm.$t("activity.info")
    }
  }), _c("a-step", {
    attrs: {
      title: _vm.$t("public.configuregoods")
    }
  }), _c("a-step", {
    attrs: {
      title: _vm.$t("public.configureDyx")
    }
  }), _c("a-step", {
    attrs: {
      title: _vm.$t("public.addsuccee")
    }
  })], 1)], 1), _c("addactivityinfo", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTab === 0,
      expression: "currentTab === 0"
    }],
    on: {
      nextStep: _vm.nextStep
    }
  }), _c("activityproduct", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTab === 1,
      expression: "currentTab === 1"
    }],
    attrs: {
      basicInformation: _vm.basicInformation
    },
    on: {
      prevStep: _vm.prevStep,
      nextStep: _vm.nextStep2
    }
  }), _c("activityDyx", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTab === 2,
      expression: "currentTab === 2"
    }],
    attrs: {
      basicInformation: _vm.basicInformation,
      basicProductContent: _vm.basicProductContent
    },
    on: {
      prevStep: _vm.prevStep,
      nextStep: _vm.nextStep
    }
  }), _c("add-activity-success", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentTab === 3,
      expression: "currentTab === 3"
    }],
    on: {
      finish: _vm.finish,
      release: _vm.release
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };